import { T } from "./translation-keys";
import { Roles } from "../enums";

export const RoleNames = {
  [Roles.SuperAdmin]: T.SUPER_ADMIN,
  [Roles.Admin]: T.ADMIN,
  [Roles.Partner]: T.PARTNER,
  [Roles.Manager]: T.MANAGER,
  [Roles.Cashier]: T.CASHIER,
};
